import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  standalone: false,
})
export class ErrorPageComponent {
  currentRoute: string;
  title: string;
  message: string;

  private readonly router = inject(Router);

  constructor() {
    this.currentRoute = this.router.url;
    this.setErrorMessage();
  }

  private setErrorMessage(): void {
    if (this.currentRoute === '/404') {
      this.title = 'Ups! Nie znaleziono treści';
      this.message = 'Treść, której szukasz, mogła zostać usunięta lub adres jest niepoprawny.';
    } else {
      this.title = 'Błąd serwera';
      this.message = 'Wystąpił błąd po stronie serwera. Spróbuj ponownie później.';
    }
  }

  goHome(): void {
    this.router.navigate(['/'], { replaceUrl: true });

  }
}
